export enum SavedMentionApiErrorEnum {
    duplicateEntity = 'COM-001',     // This entity already exist
    badReference = 'COM-002',        // A reference to another object is invalid.
    invalidModel = 'COM-003',        // Generic error when the model is invalid
    noIdOnNew = 'COM-004',           // Cannot provide an id for a new entity
    invalidBooleanQuery = 'COM-007', // The boolean query in a search is invalid
    tagLimitExceeded = 'ADVMON-002', // You have exceeded the number of tagging searches allowed in your account
}
